/**
 * @file index.ts
 * @description Индексный файл диаграмм системы управления задачами.
 * Экспортирует конфигурации для отображения диаграмм и графиков.
 * Использует интерфейс IChartPage для унифицированной типизации
 * всех компонентов диаграмм в системе.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-09-15
 * @updated 2025-09-15
 * @dependencies ['@src/types/page.types']
 * @related-files ['./schedule.page.tsx']
 */

import { IChartPage } from '@src/types/page';
import * as schedule from './schedule.page';

const items: IChartPage[] = [schedule];

export default items;
